import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "iconButtonProps", "fontSize", "TextProps", "title", "isOpen", "onClick", "onClose"];
import { IconButton, Tooltip, Typography } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "InfoTooltip__Root",
  componentId: "SD__sc-1emqpa9-0"
})(["display:flex;align-items:center;"]);
export var InfoTooltip = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      children,
      iconButtonProps,
      fontSize = 'small',
      TextProps,
      title,
      isOpen,
      onClick,
      onClose
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var tooltip = /*#__PURE__*/_jsx(Tooltip, _objectSpread(_objectSpread({
    open: isOpen,
    title: title,
    placement: "top",
    onClose: onClose,
    disableFocusListener: true,
    disableTouchListener: true,
    onClick: onClick,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx(IconButton, _objectSpread(_objectSpread({}, iconButtonProps), {}, {
      size: "small",
      onMouseOver: onClick,
      children: /*#__PURE__*/_jsx(Info, {
        color: "action",
        fontSize: fontSize
      })
    }))
  }));
  if (!children) return tooltip;
  return /*#__PURE__*/_jsxs(Root, {
    children: [/*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({}, TextProps), {}, {
      children: children
    })), tooltip]
  });
});
if (process.env.NODE_ENV !== "production") InfoTooltip.displayName = "InfoTooltip";